import {
  ChartLineUp,
  ClockUser,
  BoundingBox,
  ListStar,
  TrendUp,
  Clock,
  Speedometer,
  ListNumbers,
  CaretRightIcon,
  SlidersIcon,
} from '@phosphor-icons/react';
import TestTypeSelector from './TestTypeSelector';
import GlobalSidebarItem from '../components/sidebar/GlobalSidebar/GlobalSidebarItem';
import { useState, useEffect } from 'react';
import axios from 'axios';
import TorchGuide from '../components/generic/TorchGuide';

const PackAnalysisSidebar = ({
  currentScreen,
  onScreenChange,
  selectedTestTypes = [],
  onTestTypeChange,
  groups = [],
  subjects = [],
  categories = [],
  packTitle = 'Pack Analysis',
  loading = false,
  packId,
  testId,
  apiResponse = null,
  onResetFilters,
}) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('userProfile')));
  const [showTorchGuide, setShowTorchGuide] = useState(true);
  const [stepIndex, setStepIndex] = useState(0);

  // Torch guide steps for Test Type Selector
  const steps = [
    {
      target: '.test-type-selector-target',
      content: 'You can view complete analysis of different tests like Quizrr Full Test, Chapter Test & more from here',
      title: 'Click Here to Change Test Type',
      disableBeacon: true,
      spotlightPadding: 0,
    },
  ];

  // Check if user has completed the tour
  useEffect(() => {
    const checkIfTablet = () => {
      setShowTorchGuide(window.innerWidth > 1024);
    };

    checkIfTablet();
    window.addEventListener('resize', checkIfTablet);
    return () => window.removeEventListener('resize', checkIfTablet);
  }, []);

  const handleJoyrideCallback = async (data) => {
    const { status, index, type, action } = data;

    if (status === 'finished') {
      setStepIndex(0);
      await axios.patch('/api/user/profile', {
        packAnalysisV3TourDone: true,
      });
      const updatedUser = { ...user, packAnalysisV3TourDone: true };
      localStorage.setItem('userProfile', JSON.stringify(updatedUser));
      setUser(updatedUser);
    } else if (type === 'step:after') {
      if (action === 'next') {
        setStepIndex(index + 1);
      } else if (action === 'prev') {
        setStepIndex(Math.max(0, index - 1));
      }
    }
  };

  const menuItems = [
    { id: 'performance', label: 'Performance', icon: 'ChartLineUp' },
    { id: 'timeline', label: 'Timeline', icon: 'ClockUser' },
    { id: 'qs-type-breakup', label: 'Qs Type Breakup', icon: 'BoundingBox' },
    { id: 'quality-of-attempt', label: 'Quality of Attempts', icon: 'ListStar' },
    { id: 'time-analysis', label: 'Time Analysis', icon: 'Clock' },
    { id: 'difficulty-analysis', label: 'Difficulty Analysis', icon: 'Speedometer' },
    { id: 'chapter-analysis', label: 'Chapter Analysis', icon: 'ListNumbers' },
  ];

  // Create apiResponse structure if not provided
  const testTypeSelectorProps = {
    selectedTypes: selectedTestTypes,
    onSelect: onTestTypeChange,
    categories: categories.length > 0 ? categories : [],
    subjects: subjects,
    apiResponse: apiResponse || {
      data: {
        categories: categories.length > 0 ? categories : [],
        subjects: subjects,
      },
    },
    onResetFilters: onResetFilters,
  };

  return (
    <div className="w-full max-w-sm mx-auto py-6">
      {/* Torch Guide */}
      {!user?.packAnalysisV3TourDone && showTorchGuide && (
        <TorchGuide steps={steps} handleTorchGuideCallback={handleJoyrideCallback} stepIndex={stepIndex} />
      )}

      {/* Test Type Selector with target class for Torch Guide */}
      <div className="px-4 mb-6">
        <div className="test-type-selector-target ">
          {loading ? (
            <div className="flex items-center justify-between w-full px-4 py-3 bg-[var(--q3-accent-light)] rounded-[360px] border border-[var(--q3-accent-normal)] animate-pulse">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-[var(--q3-accent-normal)] rounded opacity-50"></div>
                <div className="w-24 h-4 bg-[var(--q3-accent-normal)] rounded opacity-50"></div>
              </div>
              <div className="w-5 h-5 bg-[var(--q3-accent-normal)] rounded opacity-50"></div>
            </div>
          ) : (
            <TestTypeSelector {...testTypeSelectorProps} />
          )}
        </div>
      </div>

      {/* Title Section */}
      <div className="px-4 ml-4 mb-6">
        {loading ? (
          <>
            <div className="w-48 h-8 bg-[var(--q3-neutral-light)] rounded animate-pulse mb-2"></div>
            <div className="w-36 h-4 bg-[var(--q3-neutral-light)] rounded animate-pulse"></div>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-[var(--q3-neutral-default)] mb-2">{packTitle}</h1>
          </>
        )}
      </div>

      {/* Navigation Menu */}
      <nav className="flex flex-col gap-1 px-4">
        {menuItems.map((item) => (
          <GlobalSidebarItem
            key={item.id}
            icon={item.icon}
            title={item.label}
            isSelected={currentScreen === item.id}
            onClick={() => onScreenChange(item.id)}
          />
        ))}
      </nav>
    </div>
  );
};

export default PackAnalysisSidebar;
